import { useState } from "react";
import { TERMS } from "../lib/brand";
import { useReveal } from "../hooks/useReveal";

export const Terms = () => {
  const headRef = useReveal();
  const [open, setOpen] = useState(0);

  return (
    <section
      id="terms"
      data-testid="terms-section"
      className="py-24 md:py-40 border-b border-black/100"
    >
      <div className="max-w-[1480px] mx-auto px-6 md:px-12 grid grid-cols-12 gap-10 md:gap-16">
        <div ref={headRef} className="col-span-12 md:col-span-5 reveal">
          <div className="label-eyebrow mb-6">The fine print · Vol. V</div>
          <h2 className="font-display text-[2.6rem] md:text-6xl leading-[0.95] tracking-[-0.015em]">
            Terms &amp; <br />
            <span className="italic">Conditions.</span>
          </h2>
          <p className="font-body text-[15px] leading-[1.85] text-black/75 mt-8 max-w-md">
            Our house rules — written plainly so every rental begins with
            clarity and ends in a handshake. By booking, you agree to the
            following:
          </p>
          <div className="mt-10 h-px w-24 bg-black" />
          <p className="label-micro opacity-60 mt-10">
            Last revised · {new Date().getFullYear()}
          </p>
        </div>

        {/* Accordion */}
        <div className="col-span-12 md:col-span-6 md:col-start-7">
          <div className="border-t border-b border-black">
            {TERMS.map((term, i) => {
              const isOpen = open === i;
              return (
                <div
                  key={term.title}
                  data-testid={`term-item-${i}`}
                  className="border-b border-black/20 last:border-b-0"
                >
                  <button
                    type="button"
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    aria-expanded={isOpen}
                    data-testid={`term-toggle-${i}`}
                    className="w-full flex items-center justify-between gap-6 py-6 md:py-8 text-left group"
                  >
                    <div className="flex items-baseline gap-6 md:gap-10">
                      <span className="label-eyebrow opacity-60 shrink-0">
                        0{i + 1}
                      </span>
                      <span className="font-display text-2xl md:text-3xl leading-[1.1] tracking-[-0.01em]">
                        {term.title}
                      </span>
                    </div>
                    <span
                      className={`font-display text-2xl md:text-3xl transition-transform duration-500 ${
                        isOpen ? "rotate-45" : ""
                      }`}
                      aria-hidden
                    >
                      +
                    </span>
                  </button>
                  <div
                    className={`grid transition-all duration-500 ease-out ${
                      isOpen
                        ? "grid-rows-[1fr] opacity-100 pb-8 md:pb-10"
                        : "grid-rows-[0fr] opacity-0"
                    }`}
                  >
                    <div className="overflow-hidden">
                      <p className="font-body text-[15px] leading-[1.85] text-black/80 max-w-2xl pr-8 pl-[5.2rem] md:pl-[5.5rem]">
                        {term.body}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
